import { useCallback, useEffect, useState } from "react";
import { Download } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { downloadCsv } from "@/lib/csv";
import { fmtDuration, shiftLabel, todayWIB } from "@/components/staff/attendance/utils";

export const MonthlyAttendance = ({ config }) => {
  const [month, setMonth] = useState(todayWIB().slice(0, 7));
  const [rows, setRows] = useState([]);

  const load = useCallback(() => {
    api.get("/admin/attendance/monthly", { params: { month } }).then((r) => setRows(r.data.rows)).catch((e) => toast.error(errMsg(e)));
  }, [month]);
  useEffect(() => { load(); }, [load]);

  const exportCsv = () => downloadCsv(`absensi-${month}.csv`,
    ["Bulan", "Nama", "Divisi", "Shift", "Hari hadir", "Jumlah shift", "Terlambat (kali)", "Total terlambat (menit)", "Total jam kerja", "Tanpa absen pulang"],
    rows.map((r) => [month, r.name, r.division, shiftLabel(config, r.shift), r.days_present, r.shifts, r.late_count, r.late_minutes, (r.work_minutes / 60).toFixed(1).replace(".", ","), r.missing_clock_out]));

  const th = "px-4 py-2.5 font-semibold";
  return (
    <div className="mt-10" data-testid="attendance-monthly">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <h3 className="font-serif font-semibold text-2xl">Rekap absensi bulanan</h3>
        <div className="flex gap-2">
          <input type="month" value={month} onChange={(e) => setMonth(e.target.value)} className="px-3 py-2 rounded-lg border border-sage-200 bg-paper text-sm" data-testid="attendance-month-input" />
          <button onClick={exportCsv} disabled={!rows.length} className="btn-forest px-4 py-2 text-sm flex items-center gap-2" data-testid="attendance-monthly-download"><Download className="w-4 h-4" /> Unduh CSV</button>
        </div>
      </div>
      <div className="card-paper mt-4 overflow-x-auto">
        <table className="w-full text-sm" data-testid="attendance-monthly-table">
          <thead><tr className="text-left text-xs text-muted2 border-b border-sage-200">
            {["Nama", "Divisi", "Shift", "Hari hadir", "Jumlah shift", "Terlambat", "Total jam kerja", "Tanpa absen pulang"].map((h) => <th key={h} className={th}>{h}</th>)}
          </tr></thead>
          <tbody className="divide-y divide-sage-200">
            {rows.map((r) => (
              <tr key={r.user_id} data-testid={`attendance-monthly-row-${r.user_id}`}>
                <td className="px-4 py-2.5 font-semibold">{r.name}</td><td className="px-4 py-2.5">{r.division || "-"}</td><td className="px-4 py-2.5">{shiftLabel(config, r.shift)}</td>
                <td className="px-4 py-2.5 font-semibold">{r.days_present} hari</td>
                <td className="px-4 py-2.5">{r.shifts}</td>
                <td className={`px-4 py-2.5 ${r.late_count ? "text-amber-700 font-semibold" : ""}`}>{r.late_count}× ({r.late_minutes} mnt)</td>
                <td className="px-4 py-2.5">{fmtDuration(r.work_minutes)}</td>
                <td className={`px-4 py-2.5 ${r.missing_clock_out ? "text-red-700" : ""}`}>{r.missing_clock_out}</td>
              </tr>
            ))}
            {rows.length === 0 && <tr><td colSpan={8} className="px-4 py-8 text-center text-muted2" data-testid="attendance-monthly-empty">Belum ada data absensi bulan ini.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
};
